import { Checkbox, CheckboxProps, Stack, Text } from '@mantine/core';

interface SettingCheckboxProps extends CheckboxProps {
  description: React.ReactNode;
}

export const SettingCheckbox: React.FC<SettingCheckboxProps> = ({ label, description, ...checkboxProps }) => (
  <Stack gap={4} align="flex-start">
    <Checkbox
      {...checkboxProps}
      label={
        <Text component="span" fz={13} fw={700} c="#555454" lts="0.3px">
          {label}
        </Text>
      }
    />
    <Text fz="xs" fs="italic" c="dimmed">
      {description}
    </Text>
  </Stack>
);
